module.exports = __webpack_public_path__ + "media/bootstrap-icons/dice-4-0acdb632.svg";